import { SystemState } from "./system.types";

export const initialState: SystemState = {
  deviceId: null,
  deviceInfo: null,
  devicePlatform: null,
  devicePublicIp: null,
  authType: null,
};
